import type { MaybeRefOrGetter } from 'vue'

const pageHeaderTitleState = shallowRef('')

export function usePageHeaderTitle(title?: MaybeRefOrGetter<string>) {
  if (title !== undefined) {
    watchEffect(() => {
      pageHeaderTitleState.value = toValue(title)
    })

    onBeforeUnmount(() => {
      pageHeaderTitleState.value = ''
    })
  }

  return pageHeaderTitleState
}

export function resetPageHeaderTitle() {
  pageHeaderTitleState.value = ''
}
